//DemoVizView.vue



<template>

	<div>

		<div class="gradient-background">
		</div>

		<div id="threeContainer">
			<ThreeDemoViz />
		</div>
		<!-- <div id="inputBar">
			<InputBar />
		</div>
		<div id="resultBar">
			<ResultBar />
		</div> -->
		<div id="header">
			<HeaderBasic />
		</div>  

	</div>

</template>

<script>


import HeaderBasic from "../components/HeaderBasic.vue";
import ThreeDemoViz from "../components/ThreeDemoViz.vue";


export default {
  components: {
	HeaderBasic,
	ThreeDemoViz,
  },
	data() {
		return {
			msg: ""
		};
	}
};
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#threeContainer {
	top: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
	position: absolute;
}

#inputBar {
	position: fixed;
	vertical-align: middle;
	top: 10%;
	left: 10px;
}

#resultBar {
	position: fixed;
	vertical-align: middle;
	right: 10px;
	top: 10%;
	margin-right: 0px;
}

#header {
	position: fixed;
	top: 2%;
}

#uploadButton {
	position: fixed;
	top: 93%;
	left: 47%;
}

.gradient-background {
	top: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
	position: absolute;
	background: #d4d4d4;
	background-image: linear-gradient(rgba(220, 220, 222, 1),rgba(194, 194, 207, 1));
}

</style>









